export default "/images/greenarrowrightIcon.png?32bda94f633165a8481118f30ffc0456";